import React from "react";
import Fraction from "fraction.js";

const IngredientQuantity = ({ quantity }) => {

  const formatFraction = (fraction) => {
    const integer = Math.floor(Number(fraction.n / fraction.d));
    const numerator = Number(fraction.n % fraction.d);
    const denominator = Number(fraction.d);

    return (
      <math xmlns="http://www.w3.org/1998/Math/MathML">
        {integer > 0 && <mn>{integer}</mn>}
        {numerator > 0 && (
          <mfrac>
            <mi>{numerator}</mi>
            <mi>{denominator}</mi>
          </mfrac>
        )}
      </math>
    )
  }

  const isFraction = (input) => {
    try {
      if (input.includes('.')) return false;
      new Fraction(input); 
      return true; // If no error is thrown, it's a valid fraction
    } catch (error) {
      return false;
    }
  };

  const renderQuantity = () => {
    try {
      if (isFraction(quantity)) {
          const fraction = new Fraction(quantity);
          return formatFraction(fraction);
      } else {
        return quantity
      }
    } catch (error) {
      return quantity;
    }
  }

  return (
    <>
      {renderQuantity()}
    </>
  )
}

export default IngredientQuantity;